<template>
  <NebulaSidebar
    class="editor-page-drawer-sidebar"
    @sidebar-collapsed="getSidebarCollapsed($event)"
  >
    <template #sidebar-content>
      <div
        v-if="lessonName || isAssigned"
        class="editor-page-drawer-sidebar__header"
      >
        <NebulaBadge
          v-if="lessonName"
          :text="lessonName"
          size="s"
          class="editor-page-drawer-sidebar__lesson-number-badge"
        />
        <NebulaBadge
          v-if="isAssigned"
          :text="$t('Assigned')"
          size="s"
          class="editor-page-drawer-sidebar__assigned-badge"
        />
      </div>
      <EditorPageDrawer
        class="editor-page-drawer-sidebar__content"
        :is-disabled="isSidebarCollapsed"
      />
    </template>
  </NebulaSidebar>
</template>

<script>
import {
  NebulaSidebar,
  NebulaBadge,
} from '@discoveryedu/nebula-components';
import EditorPageDrawer from '@/components/EditorPageDrawer.vue';

export default {
  name: 'EditorPageDrawerSidebar',
  components: {
    EditorPageDrawer,
    NebulaBadge,
    NebulaSidebar,
  },
  data() {
    return {
      isSidebarCollapsed: false,
    };
  },
  props: {
    lessonName: {
      type: String,
      default: null,
    },
    isAssigned: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getSidebarCollapsed(isCollapsed) {
      this.isSidebarCollapsed = isCollapsed;
    },
  },
};
</script>

<style lang="stylus">
.editor-page-drawer-sidebar {
  background: $nebula-color-white;
  box-shadow: $nebula-shadow-400;
  height: 100%;
  padding: 0;
  position: relative;
  width: 240px;
  z-index: 1; // Above editor stage area

  &__header {
    border-bottom: 1px solid $nebula-color-platform-interface-300;
    display: flex;
    flex: 0 0 auto;
    gap: $nebula-space-1x;
    padding: $nebula-space-2x;
  }

  &__content {
    flex: 1 1 auto;
  }

  &__lesson-number-badge {
    --nebula-badge-background-color: $nebula-color-science-primary-500;
  }

  &__assigned-badge {
    --nebula-badge-background-color: $nebula-color-platform-neutral-800;
  }

  &.nebula-sidebar--collapsed {
    margin-inline-start: -215px;
  }

  .nebula-sidebar__inner {
    display: flex;
    flex-direction: column;
    padding: 0;
  }

  .nebula-sidebar__toggle-nav-button {
    z-index: 2; // Above page drawer sticky headers
  }
}
</style>
